import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '../../../../components/atoms/PrimaryButton'
import AlertContext from '../../../../context/alert/alertContext'
import AuctionContext from '../../../../context/template/auction/auctionContext'
import UserContext from '../../../../context/user/userContext'
import CommonContext from '../../../../context/common/commonContext'
import Loaders from '../../../../components/molecules/Loaders'
import ReportContext from '../../../../context/report/reportContext'
import {
    mapData,
    handleRedirectInternal,
    dateTimeFormatFunction,
} from '../../../../common/components'
import { initialFilterFunction } from '../../../species/dynamic/common/FieldFunction'
import moment from 'moment'
import CustomDialog from '../../../organisms/Dialog'
import { Button, Popover } from '@mui/material'
import BaseTablePage from '../../../species/dynamic/common/BaseTablePage'
import { useFormik } from 'formik'

const AuctionCommonTable = (props) => {
    const alertContext = useContext(AlertContext)
    const auctionContext = useContext(AuctionContext)
    const { getAllUsers } = useContext(UserContext)

    const reportContext = useContext(ReportContext)
    const commonContext = useContext(CommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const { setBidHistoryValue } = commonContext
    const { getAllExportDownload } = reportContext

    const { setAlert } = alertContext
    const {
        all_auctions,
        getAllAuctions,
        changeAuctionStatus,
        responseStatus: responseStatusAuction,
        clearResponse: clearResponseAuction,
    } = auctionContext
    const history = useHistory()

    const [initialValues, setInitialValues] = useState({})
    const [initialUpdate, setInitialUpdate] = useState(true)
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [filterArray, setFilterArray] = useState({})
    const [searchProduct, setSearchProduct] = useState(false)
    const [reload, setReload] = useState(false)
    let action = props.action

    const [fieldEditModal, setFieldEditModal] = useState(false)
    const [fieldData, setFieldData] = useState({})

    /* Start of Formik Selection Action Function */
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            auction_id: '',
            date_closed: dateTimeFormatFunction(new Date()),
            mainUpdate: false,
        },
        onSubmit: (values) => {
            if (
                values.action === 'removed' ||
                values.action === 'closenow' ||
                values.action === 'date_closed'
            ) {
                const value = values
                if (value.action === 'date_closed') {
                    value.date_closed = moment(
                        value.date_closed,
                        'MM-DD-YYYY h:mm a'
                    ).format()
                } else {
                    value.date_closed = null
                }
                setIsLoading(true)
                changeAuctionStatus(value)
            }
        },
    })
    /* End of Formik Selection Action Function */

    /* Start Dynamic filter handle */
    useEffect(() => {
        setInitialValues({})
        setInitialEmptyValues({})
        setInitialUpdate(true)
        setSearchProduct(false)

        if (props.searchInfo.data && props.searchInfo.data.length) {
            let mapValueArray = props.searchInfo.data
            let show = initialFilterFunction(mapValueArray)
            setInitialValues({ ...props.customFilter, ...show })
            setInitialEmptyValues({ ...props.customFilter, ...show })
            setFilterArray(props.searchInfo)

            setTimeout(() => {
                if (Object.keys(show).length) {
                    setSearchProduct(true)
                    setInitialUpdate(false)
                    setReload(!reload)
                }
            }, 1000)
        } else {
            setInitialValues(props.customFilter)
            setInitialEmptyValues(props.customFilter)

            setTimeout(() => {
                if (Object.keys(props.customFilter).length) {
                    setSearchProduct(true)
                    setInitialUpdate(false)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [props.searchInfo, action])
    /* End Dynamic filter handle */

    /* Start of Fetch Table Body Function */
    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            having: {
                future_active: {
                    value:
                        action === 'upcomming' || action === 'upcoming' ? 1 : 0,
                    type: 'in',
                    field: 'future_active',
                },
            },
            filters: initialValues,
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllAuctions(values)
        },
    })
    useEffect(() => {
        setTableBody([])
        setIsLoading(true)

        if (searchProduct) {
            if (action === 'upcomming' || action === 'upcoming') {
                formik.values.having.future_active.value = 1
            } else {
                formik.values.having.future_active.value = 0
            }
            getAllAuctions(formik.values)
            setSearchProduct(false)
        }

        return () => {
            setTableBody([])
        }
    }, [searchProduct, action])
    useEffect(() => {
        if (all_auctions) {
            setTableBody(
                all_auctions.records.length ? all_auctions.records : []
            )
        }
        setIsLoading(false)
    }, [all_auctions])
    /* End of Fetch Table Body Function */
    useEffect(() => {
        formik.setFieldValue('filters', initialValues)
    }, [initialValues])
    /* Start of Listing Edit Functions */

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'use') {
            handleRedirectInternal(history, `auction/use/${id}`)
        } else {
            props.toggleFullScreenPopup(true, type, id)
        }
    }

    const onClickView = (id, secondaryID, type) => {
        props.toggleFullScreenPopup(true, type, id)
    }

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            buttonType: 'edit',
            clickType: 'editTemplate',
            onclick: onClickEdit,
            tooltipTitle: props.edit_tooltip
                ? props.edit_tooltip
                : 'Edit Auction',
        })

        actionPush.push({
            buttonType: 'library_add_check',
            clickType: 'use',
            onclick: onClickEdit,
            tooltipTitle: props.use_tooltip
                ? props.use_tooltip
                : 'Use Template',
        })

        return actionPush
    }
    /* End of Listing Edit Functions */

    /* Start of Table Top Action Function */
    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.auction_id = data
        formikSelection.values.date_closed = dateTimeFormatFunction(new Date())
        if (action === 'removed' || action === 'closenow') {
            setChangeStatus(true)
        } else if (action === 'date_closed') {
            formikSelection.values.mainUpdate = true
            setChangeStatus(true)
        }
    }

    useEffect(() => {
        if (responseStatusAuction) {
            if (
                responseStatusAuction.status === 'success' &&
                responseStatusAuction.from === 'auctionchange'
            ) {
                setChangeStatus(false)
                getAllAuctions(formik.values)
            } else if (responseStatusAuction.from === 'auctionAction') {
                props.toggleFullScreenPopup(false)
                getAllAuctions(formik.values)
            }
        }
    }, [responseStatusAuction])

    /* End of Table Top Action Function */

    /* Start of Table Top Value Function */
    const [tableActions, setTableActions] = useState([])
    let incomingAction = props.tableActionString

    useEffect(() => {
        let tempTableActions = [
            {
                label: 'Move to Active',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'open',
                action: 'draft',
            },
            {
                label: 'Assign to Auction',
                icon: <span className="material-icons">add_task</span>,
                onclick: onSelectMultiProducts,
                type: 'auction_assign',
                action: 'draft',
            },
            {
                label: 'Delete',
                icon: <span className="material-icons">delete</span>,
                onclick: onSelectMultiProducts,
                type: 'removed',
                action: 'draft,open,unsold',
            },
            {
                label: 'Relist',
                icon: <span className="material-icons">restart_alt</span>,
                onclick: onSelectMultiProducts,
                type: 'relist',
                action: 'unsold',
            },
            {
                label: 'Move to Unsold',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'unsold',
                action: 'open,sold',
            },
            {
                label: 'Change End Date',
                icon: <span className="material-icons">today</span>,
                onclick: onSelectMultiProducts,
                type: 'date_closed',
                action: 'open',
            },
        ]
        tempTableActions = tempTableActions.filter((d) =>
            d.action.toString().split(',').includes(action) &&
            incomingAction.length
                ? incomingAction.includes(d.type)
                : false
        )
        setTableActions(tempTableActions)
    }, [action, incomingAction])
    /* End of Table Top Value Function */

    /* Start of Table Body Value Function */
    const [arrayValue, setArrayValue] = useState([])
    useEffect(() => {
        if (props.tableValue.length) {
            let dynamicValueAssign = props.tableValue

            // dynamicValueAssign = dynamicValueAssign.filter((item) =>
            //     item.field !== 'action'
            //         ? action !== 'sold' && action !== 'relisted'
            //             ? item.field !== 'winner_email' &&
            //               item.field !== 'buynow_common_invoice' &&
            //               item.field !== 'buynow_paid_date' &&
            //               item.field !== 'buynow_qty' &&
            //               item.field !== 'buynow_amount' &&
            //               item.field !== 'winner_first_name,winner_last_name'
            //             : action === 'open'
            //             ? item.field !== 'wprice'
            //             : true
            //         : false,
            // )
            let index = dynamicValueAssign.findIndex((e) => e.field == 'action')
            let arrayVal = []
            if (index > 0) {
                arrayVal = dynamicValueAssign.filter(
                    (item) => item.field !== 'action'
                )
                arrayVal.push({
                    name: 'action',
                    field: 'action',
                    type: 'button',
                    clickID: 'id',
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Action',
                    isMultiple: getMultipleAction(),
                    tableShow: 1,
                })
            } else {
                arrayVal = dynamicValueAssign
                arrayVal.push({
                    name: 'action',
                    field: 'action',
                    type: 'button',
                    clickID: 'id',
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Action',
                    isMultiple: getMultipleAction(),
                    tableShow: 1,
                })
            }
            setArrayValue(arrayVal)
        }
    }, [props.tableValue, action])
    /* End of Table Body Value Function */

    /* Start of Bulk Upload Function */
    const [bulkPopup, setBulkPopup] = useState(false)
    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }
    /* End of Bulk Upload Function */

    /* Start of Search Info Function */
    const searchInfo = filterArray.data?.length
        ? { formik: formik, ...filterArray }
        : { formik: formik }
    /* End of Search Info Function */

    /* Start Auction Lot Action Function */
    const [assignAuction, setAssignAuction] = useState(false)
    const [activeAuctions, setActiveAuctions] = useState([])
    const changeAssignAuction = () => {
        setAssignAuction(!assignAuction)
    }

    /* End of Auction Lot Action Function */

    /* Start Date Close Function */
    const dateClosed = {
        formik: formikSelection,
        data: [
            {
                label: 'Change End Date *',
                placeholder: 'Enter End Date',
                disablePast: true,
                type: 'datetime',
                class: `col-12 ${
                    formikSelection.values.mainUpdate ? '' : 'd-none'
                }`,
                name: 'date_closed',
                minDate: dateTimeFormatFunction(new Date()),
                minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                    new Date()
                )}`,
            },
        ],
    }

    /* End  Date Close Function */

    const [fieldValues, setFieldValues] = useState({})
    const changeFieldEditModal = (fieldValue, data) => {
        setFieldEditModal(!fieldEditModal)
        setFieldValues(data)
        let fieldUpdateData = props.dynamicFieldValues?.filter(
            (d) => d.name == fieldValue.field
        )[0]
        setFieldData({ ...fieldUpdateData, class: '' })
    }

    const [dynamicFieldInitialValues, setDynamicFieldInitialValues] = useState(
        {}
    )

    const [dynamicFieldValidationSchema, setDynamicFieldValidationSchema] =
        useState(null)

    useEffect(() => {
        setDynamicFieldInitialValues({
            id: fieldValues?.id,
            avatar: fieldValues?.avatar,
            description: fieldValues?.description,
            name: fieldData?.name,
            [fieldData.name]: fieldValues[fieldData.name],
        })
    }, [fieldValues, fieldData])

    const dynamicFieldFormik = useFormik({
        initialValues: dynamicFieldInitialValues,
        validateOnBlur: false,
        validationSchema: dynamicFieldValidationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {},
    })

    return (
        <>
            <div className="dashboard listing maillisting">
                {initialUpdate ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <BaseTablePage
                        arrayValue={arrayValue}
                        isLoading={isLoading}
                        searchInfo={searchInfo}
                        tableBody={tableBody}
                        action={props.action}
                        tableActions={tableActions}
                        allData={all_auctions}
                        changeTableFunction={getAllAuctions}
                        editTableCell={changeFieldEditModal}
                        onSelectMultiProducts={onSelectMultiProducts}
                        listView={props.listView}
                        toggleFullScreenPopup={props.toggleFullScreenPopup}
                        enableEditTableCell={props.enableEditTableCell}
                        enableColumnEdit={props.enableColumnEdit}
                        dynamicFieldValues={props.dynamicFieldValues}
                        columnStorageVariable={props.columnStorageVariable}
                        ignoreEditArray={[
                            'id',
                            'created_at',
                            'updated_at',
                            'projectcount',
                            'market_status',
                        ]}
                    />
                )}
            </div>

            <CustomDialog
                title={'Change auction status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'closenow'
                        ? 'Are you sure you want to close the auctions and lots related'
                        : 'Are you sure you want to change the status'}
                </h5>
                {formikSelection.values.action === 'date_closed' && (
                    <div className="row">{mapData(dateClosed)}</div>
                )}
                <div className="actionWrapper">
                    <Button
                        id="auction_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="auction_table_submit"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                className="editFieldModal"
                title={`Edit ${fieldData?.label}`}
                open={fieldEditModal}
                function={() => setFieldEditModal(!fieldEditModal)}
            >
                <div className="row">
                    <div className="col-12">
                        {mapData({
                            formik: dynamicFieldFormik,
                            data: [fieldData],
                        })}
                    </div>
                </div>

                <div className="actionWrapper">
                    <Button onClick={() => setFieldEditModal(false)}>
                        Cancel
                    </Button>
                    <PrimaryButton type="submit" label="Confirm" />
                </div>
            </CustomDialog>
        </>
    )
}

export default AuctionCommonTable
